module.exports = __webpack_public_path__ + "img/client (8).4b5672eb.jpg";